import { render, staticRenderFns } from "./HeaderAccount.vue?vue&type=template&id=8dbfdb16&"
import script from "./HeaderAccount.vue?vue&type=script&lang=js&"
export * from "./HeaderAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports